<div class="widget-container" *ngIf="data.length">
  <div class="sub-title">
    <div class="sub-title">
      Consider these domains for your blocklist.<br>Their performance doesn't align with your other targeted domains.
    </div>
  </div>
  <ol class="domain-list">
    <li *ngFor="let item of data" class="item">
      <a class="link-url" [href]="'//www.' + item" [title]="item" target="_blank">{{ item }}</a>
    </li>
  </ol>
</div>
<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data *ngIf="!loading && !data.length" class="wide-container" [svgSrc]="noDataView"></app-no-widget-data>
